import React from 'react';
import styled from '@emotion/styled';
import { MaybeCognitoError } from '@move-frontend/auth';
import { ArrowButton, AsyncDataPlaceholder, Row } from '../../../../../../ui';
import { DetailsFormSection as Section } from '../DetailsFormSection';
import { TermsAndConditions } from '../../../../../auth/shared/form-fields/TermsAndConditions';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';
import { SignUpError } from './SignUpError';
import { SaveDetails } from './SaveDetails';
import { SubmitError } from './SubmitError';
import { SaveDetailsError } from './SaveDetailsError';
import { theme } from '../../../../../shared/styles';
import { Color } from '../../../../../shared/styles/Color';

const ActionsRow = styled.div`
	display: flex;
	justify-content: flex-end;
`;

const StyledArrowButton = styled(ArrowButton)`
	font-family: inherit;
	border-radius: 4px;
	box-shadow: 0px -3px 0px 0px ${Color.PrimaryDark} inset;
	outline: none;

	&:focus-visible {
		outline: ${theme.button?.primary?.focus?.outline};
	}
`;

export interface ISubmitFormData {
	termsAndConditions: boolean;
	saveDetails?: boolean;
}

interface ISubmitProps {
	signUpError?: MaybeCognitoError;
	saveDetailsError?: MaybeCognitoError;
	submitError?: Error;
	canSaveDetails?: boolean;
	submitButtonText: string;
	hasHiddenConsentCheckbox?: boolean;
	hasHiddenRememberDetailsCheckbox?: boolean;
}

export const Submit = ({
	signUpError,
	saveDetailsError,
	canSaveDetails,
	submitButtonText,
	submitError,
	hasHiddenConsentCheckbox,
	hasHiddenRememberDetailsCheckbox,
}: ISubmitProps) => {
	const {
		formState: { isSubmitting },
	} = useDetailsFormContext();

	const disabled = isSubmitting;

	return (
		<>
			{isSubmitting && <AsyncDataPlaceholder />}
			<Section>
				{!hasHiddenConsentCheckbox && (
					<Row columns={1}>
						<TermsAndConditions />
					</Row>
				)}
				{canSaveDetails && !hasHiddenRememberDetailsCheckbox && (
					<Row columns={1}>
						<SaveDetails />
					</Row>
				)}
				{signUpError && <SignUpError error={signUpError} />}
				{saveDetailsError && <SaveDetailsError error={saveDetailsError} />}
				{submitError && <SubmitError error={submitError} />}
				<ActionsRow>
					<StyledArrowButton type="submit" disabled={disabled}>
						{submitButtonText}
					</StyledArrowButton>
				</ActionsRow>
			</Section>
		</>
	);
};
